var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1172(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(-567 -2424)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(567 2424)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(551.667 2434.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M188.86,208.248h-7.526a1.224,1.224,0,0,0-1.224,1.224v20.754a.408.408,0,0,0,.408.408h9.159a.408.408,0,0,0,.408-.408V209.472A1.224,1.224,0,0,0,188.86,208.248Z",
    transform: "translate(-139.767 -191.249)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M341.139,298.5h-7.525a1.224,1.224,0,0,0-1.224,1.224V313.11a.408.408,0,0,0,.408.408h9.158a.408.408,0,0,0,.408-.408V299.722A1.224,1.224,0,0,0,341.139,298.5Z",
    transform: "translate(-279.616 -274.132)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M36.669,364.758H29.143a1.224,1.224,0,0,0-1.224,1.224v7.978a.408.408,0,0,0,.408.408h9.158a.408.408,0,0,0,.408-.408v-7.978A1.224,1.224,0,0,0,36.669,364.758Z",
    transform: "translate(0 -334.983)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M179.548,3.768l-2.7-.76a.817.817,0,0,1-.461-.337L174.864.367a.816.816,0,0,0-1.363,0l-1.52,2.305a.816.816,0,0,1-.461.337l-2.7.76a.816.816,0,0,0-.409,1.3l1.741,2.114a.816.816,0,0,1,.185.561l-.146,2.811a.816.816,0,0,0,1.117.8l2.576-1.024a.816.816,0,0,1,.6,0l2.576,1.024a.816.816,0,0,0,1.117-.8l-.146-2.811a.817.817,0,0,1,.185-.561l1.741-2.114A.816.816,0,0,0,179.548,3.768Z",
    transform: "translate(-128.85 0)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M65.8,103.417l2.932-1.386a1.224,1.224,0,0,0-1.046-2.214L64.757,101.2a1.224,1.224,0,1,0,1.046,2.214Z",
    transform: "translate(-33.187 -91.561)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M354.264,11.754l2.873-1.366a1.224,1.224,0,1,0-1.052-2.211l-2.873,1.366a1.224,1.224,0,1,0,1.052,2.211Z",
    transform: "translate(-298.098 -7.4)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M64.757,10.389l2.932,1.386a1.224,1.224,0,1,0,1.046-2.214L65.8,8.175a1.224,1.224,0,0,0-1.046,2.214Z",
    transform: "translate(-33.187 -7.4)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M353.212,102.273l2.873,1.366a1.224,1.224,0,1,0,1.052-2.211l-2.873-1.366a1.224,1.224,0,1,0-1.052,2.211Z",
    transform: "translate(-298.097 -91.784)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1172);
export default __webpack_public_path__ + "static/media/Group 1172.e776d794c97215d962b7db51025cd272.svg";
export { ForwardRef as ReactComponent };